import { AuthenticationService } from './authentication-service.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { UserService } from '../user.service';
import { PolicyDataService } from '../my-insurance/data-services/policy-data.service';
import { ChangeProfileEmailService } from '../profile-settings/change-profile-email.service';
import { ClaimsDataService } from '../_claims/claims-data.service';
import { Capacitor } from '@capacitor/core';
import { AppRatingService } from '../pwa-service/app-rating.service';
import { BiometricAuthService } from '../biometric-auth/biometric-auth.service';
import { CustomerProfileService } from '../customer-profile/customer-profile.service';
import { PaperlessService } from './paperless.service';
import { CustomerBannerService } from '../banner/customer-banner/customer-banner.service';
import { UserDataService } from '@services/data-services/user-data.service';
import { ActionWidgetService } from '@services/widget/action-widget.service';
import { OktaAuthService } from './okta-auth.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  private subscription: Subscription;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private userService: UserService,
    private policyDataService: PolicyDataService,
    private changeProfileEmailService: ChangeProfileEmailService,
    private claimsDataService: ClaimsDataService,
    private appRatingService: AppRatingService,
    private bioMetricAuth: BiometricAuthService,
    private cps: CustomerProfileService,
    private paperlessService: PaperlessService,
    private customerBannerService: CustomerBannerService,
    private userDataService: UserDataService,
    private widgetService: ActionWidgetService,
    private oktaAuthService: OktaAuthService
  ) {}

  clearOnLogout() {
    this.claimsDataService.clearClaimsData();
    this.userService.clearUser();
    this.policyDataService.updatePolicyDetails([]);
    this.changeProfileEmailService.clearEmail();
    // this.subscription.unsubscribe();
    this.cps.clearModalTitle();
    this.cps.clearTimeFrameFor5Months();
    this.cps.clearTimeFrameForRenewalDue30Days();
    this.paperlessService.clearPaperlessPopup();
    this.customerBannerService.clearCustomerBannerData(); 
    this.userDataService.clear();    
  }

  async logout() {
    this.actionWidgetBeforeLogout();
    this.authService.logout();
    this.bioMetricAuth.noShowBio = true;
    await this.oktaAuthService.logout();
    this.clearOnLogout();
    localStorage.removeItem('prevEftRoute');
    localStorage.removeItem('currentUser');
    localStorage.clear();
    if (Capacitor.isNativePlatform()) {
      this.appRatingService.rateApp();
    }
  }

  unsubscribe() {
    this.subscription.unsubscribe();
  }

  private actionWidgetBeforeLogout(){
    this.widgetService.saveLastActivitiesAsWidgets();
    this.widgetService.clearCustomWidgets();
  }
}
